import { defineStore } from 'pinia';
import { useRuntimeConfig } from 'nuxt/app'
import { useSnakeCaseFilter } from '../composables/SnakecaseFilter'
export const useTrackingStore = defineStore('tracking', {
  state: () => {
    return {
      trackingData: {},
      keywords: '',
      route: ''
    }
  },
  actions: {
    updateKeywords(_keywords?: string) {
      this.keywords = _keywords ? useSnakeCaseFilter(_keywords) : '';
    },
    updateRoute(_route: string) {
      this.route = _route
    },
    sendTrackingData(eventData: Record<string, string> = {}) {
      if (typeof window !== 'undefined' && window.dataLayer) {
        const config = useRuntimeConfig();
        const countryCode = config.public["country"];
        const className = document?.getElementsByClassName('facility-name')?.item(0)?.textContent;
        let routeBits = this.route ? this.route.split('/')?.filter((bit) => bit !== '') : []
        const pageName = routeBits?.length >= 1 ? routeBits[routeBits.length - 1] : 'homepage';
        const pageType = routeBits?.[0]?.replace(/-/g, '_')
        const siteLevelTwo = pageType ? useSnakeCaseFilter(pageType) : 'homepage';
        routeBits = routeBits.slice(1, routeBits.length - 1)
        const [page_chapter1, page_chapter2, page_chapter3, page_chapter4] = routeBits;

        const dataToReturn = {
          ...eventData,
          site_level2: siteLevelTwo,
          ...(pageName ? {page: useSnakeCaseFilter(pageName)} : {}),
          ...(page_chapter1 ? {page_chapter1: useSnakeCaseFilter(page_chapter1)} : {}),
          ...(page_chapter2 ? {page_chapter2: useSnakeCaseFilter(page_chapter2)} : {}),
          ...(page_chapter3 ? {page_chapter3: useSnakeCaseFilter(page_chapter3)} : {}),
          ...(page_chapter4 ? {page_chapter4: useSnakeCaseFilter(page_chapter4)} : {}),
          ...(className ? {facility_name: useSnakeCaseFilter(className)} : {}),
          site_language: countryCode,
        };
        window.dataLayer.push(dataToReturn);
        this.keywords = ''
      }
      this.trackingData = {};
    }
  },
  getters: {
    getKeywords: (state) =>  state.keywords
  }
});
